import axios from "axios";
export const state = {
    audits: [],
    tats: [],
};
export const getters = {
    Audits: state => state.audits.data,
    Turnaround: state => state.tats,
};

export const mutations = {
    SET_AUDITS(state, newValue) {
        state.audits = newValue;
    },
    SET_TURNAROUND(state, newValue) {
        state.tats = newValue;
    },
};

export const actions = {
    fetchAuditTrials({ commit, dispatch }) {
        axios.get('audits').then(audit => {
            commit('SET_AUDITS', audit.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },
    fetchTurnaround({ commit, dispatch }) {
        axios.get('turnaround').then(tat => {
            commit('SET_TURNAROUND', tat.data)
        }).catch((eror) => {
            if (eror.response.status == 401) {
                dispatch('auth/logout', null, { root: true })
            }
        })
    },

};